<template>
    <div class="input-group">
        <input
            :id="id"
            :list="id+'datalist'"
            class="form-control"
            v-model="_time"
            :v-validate="vvalidate"
            :data-vv-scope="datavvscope"
            :name="name"
            :data-vv-as="datavvas"
        />
        <datalist :id="id+'datalist'">
            <option v-for="t in times" :value="t" />
        </datalist>
    </div>
</template>

<script>

    export default {
        name: 'TimeInput',
        props: [
            'tim',
            'id',
            'vvalidate',
            'datavvscope',
            'name',
            'datavvas',
        ],
        data: function () {
            return {
                times: [
                    '00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
                    '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
                    '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
                    '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
                ]
            };
        },
        model: {
            prop: "tim",
            event: "input"
        },
        methods: {
        },
        computed: {
            _time: {
                get: function() {
                    return this.tim
                },
                set: function (val) {
                    this.$emit("input", val);
                }
            }
        }
    }


</script>